const PropTypes = require('prop-types');
//@vendor
const React = require('react');
// @helper
const { formatText } = require('core/i18n').i18n;
// @utilities
const { getEstatesToRequest } = require('utilities/mortgageHelper');
// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestCostWafer = require('components/mortgageRequest/mortgageRequestCostWafer/mortgageRequestCostWafer');

const MortgageRequestSimpleNoteRequestCostWafer = props => {
    const {
        immEstates,
        simpleNoteCost,
        className,
        isClientWithoutAccounts,
        summaryDocumentation
    } = props;
    const simpleNoteCount = getEstatesToRequest(immEstates, summaryDocumentation).length;
    const totalAmountCost = simpleNoteCount * simpleNoteCost;
    const amountCost = MortgageRequestCurrencyHelp({ currency: totalAmountCost });
    const amount = <span>{amountCost} <sup>(*)</sup></span>;
    const footNote = formatText('mortgageRequestSimpleNoteRequestCostWafer-costFootNote', [simpleNoteCount]);
    const text = isClientWithoutAccounts ? "mortgageRequestSimpleNoteRequestCostWafer-infoTextNoClient" : 'mortgageRequestSimpleNoteRequestCostWafer-infoText';

    return (
        <MortgageRequestCostWafer
            title="mortgageRequestSimpleNoteRequestCostWafer-infoTitle"
            text={text}
            amount={amount}
            label="mortgageRequestSimpleNoteRequestCostWafer-taxLabel"
            hasFootNote
            footNote={footNote}
            className={className}
        />
    );
};

MortgageRequestSimpleNoteRequestCostWafer.propTypes = {
    immEstates: PropTypes.object.isRequired,
    simpleNoteCost: PropTypes.number.isRequired,
    infoText: PropTypes.string,
    className: PropTypes.string,
    isClientWithoutAccounts: PropTypes.bool,
    summaryDocumentation: PropTypes.object
};

module.exports = MortgageRequestSimpleNoteRequestCostWafer;
